import * as Updates from 'expo-updates';
import Analytics from '@/utils/analytics';
import Constants from 'expo-constants';
import i18n from '@/utils/i18n';
import React, { useCallback, useState } from 'react';
import { captureException } from '@/utils/sentry';
import { ForceUpgradeContent } from './force-upgrade-content';
import { isActivePartnerApp, partnerSupplier } from '@/utils/environment';
import { useToasts } from '@/contexts/toast-context';

export interface Props {
  appMinimumVersion: string | null;
}

export const OTAUpgradeScreen: React.FC<Props> = ({ appMinimumVersion }) => {
  const [isLoading, setIsLoading] = useState(false);
  const { showErrorToast } = useToasts();

  const fetchAndReload = useCallback(async () => {
    setIsLoading(true);
    try {
      const { isNew } = await Updates.fetchUpdateAsync();
      if (!isNew) {
        const appVersion = Constants.expoConfig!.version!;
        Analytics.track('unsupported_screen.ota_update_error', {
          appMinimumVersion,
          appVersion,
        });
        throw new Error('Force update OTA not available');
      }
      await Updates.reloadAsync();
    } catch (e) {
      showErrorToast();
      setIsLoading(false);

      if (isActivePartnerApp) {
        captureException(e);
      }
    }
  }, [appMinimumVersion, showErrorToast]);

  return (
    <ForceUpgradeContent
      buttonProps={{
        children: i18n.t('refresh'),
        loading: isLoading,
        onPress: fetchAndReload,
        trackingData: {
          name: 'unsupported_screen.refresh_button',
          properties: {
            businessOrganizationUUID: partnerSupplier.businessOrganizationUUID,
          },
        },
      }}
      footerText={i18n.t('unsupported_version.ota_footer')}
      subtitle={i18n.t('unsupported_version.ota_subtitle')}
      title={i18n.t('unsupported_version.ota_title')}
    />
  );
};
